import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'
import config from '../firebase.config'

if (firebase.apps.length < 1) {
  firebase.initializeApp(config)
}

firebase.auth().languageCode = 'es_419'

export const auth = firebase.auth()
export const storage = firebase.storage()
export default firebase
